import { getLocaleFromPathname } from 'i18n/util/localeUrl'
import { isEnabledLocale } from 'i18n/util/localeMatcher'
import { reportClientMessage } from 'services/errorReportingService'

export function reportInvalidUrlLocaleIfPresent(
  pathname: string,
  enabledLocales?: Array<string>,
): void {
  const locale = getLocaleFromPathname(pathname)
  if (locale && !isEnabledLocale(locale, enabledLocales)) {
    reportClientMessage('url_locale_invalid', { pathname, locale }, 'warning', {
      domain: 'i18n',
      surface: 'url_locale',
    })
  }
}
